<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose"
        >
        <ul class="dialogul">
            <li class="left">
                <img :src="url+banner.images" alt="" class="bg">
            </li>
            <li class="right">
                <div v-if="dialogVisible1">
                    <input type="text" placeholder="输入手机号码" v-model="phone">
                    <button @click="submit">提交</button>
                </div>
                <div v-if="!dialogVisible1">
                    <img :src="imgurl" alt="">
                    <p>扫码立即咨询更多</p>
                </div>
            </li>
        </ul>
    </el-dialog>
</template>

<script>
var that
import { bottom,fromMsg,rotationmap } from '@/api/api'
export default {
    name:"dialog",
    props:{
        dialogVisible1:{
            default:true
        },
        imgurl:{
            default:""
        }
    },
    data(){
        return {
            url:window.url,
            dialogVisible:true,
            
            msg:[],
            phone:"",
            banner:{}
        }
    },
    mounted(){
        that = this
        if(this.imgurl==""){
            bottom().then((response) => {
                that.msg = response.data.data[0]
                that.imgurl=url+that.msg[0].image
            })
        }
        rotationmap({'type':12}).then((response) => {
            that.banner = response.data.data[0]
        })
    },
    methods:{
        isPhoneNumber(str) {
            var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (!myreg.test(str)) {
                return false
            } else {
                return true
            }
		},
        submit(){
            if(!this.isPhoneNumber(this.phone)){
                this.$message('请填写正确的手机号码');
                return false;
            }
            fromMsg({'phone':this.phone}).then((response) => {
                this.$message('提交成功');
                this.dialogVisible1 = false
            })
        },
        handleClose(done){
            this.$emit("tcstatus", false);
        }
    }
}
</script>

<style lang="less" scp>
    .el-dialog__body,.el-dialog__header{
        padding: 0!important;
    }
    @media (min-width:750px) {
        .dialogul{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 600px;
            .left{
                flex: 0 0 40%;
                height: 100%;
                display: flex;
                align-items: center;
                background-color: #1343D5;
                justify-content: center;
                .bg{
                    width: 90%;
                }
            }
            .right{
                flex: 0 0 60%;
                text-align: center;
                input{
                    width: 300px;
                    border-bottom: 1px solid #1472FF;
                    padding: 10px;
                    font-size: 20px;
                }
                button{
                    display: block;
                    margin:0 auto;
                    width: 300px;
                    padding: 10px;
                    background-color: #1472FF;
                    color: #fff;
                    border-radius: 50px;
                    margin-top: 20px;
                    font-size: 20px;
                    cursor: pointer;
                }
            }
        }
    }
    @media screen and (max-width:750px) {
        .dialogul{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 200px;
            .left{
                display: none;
                flex: 0 0 40%;
                height: 100%;
                // display: flex;
                align-items: center;
                background-color: #1343D5;
                justify-content: center;
                .bg{
                    width: 90%;
                }
            }
            .right{
                flex: 0 0 100%;
                text-align: center;
                input{
                    width: 90%;
                    border-bottom: 1px solid #1472FF;
                    padding: 10px;
                    font-size: 20px;
                }
                button{
                    display: block;
                    margin:0 auto;
                    width: 90%;
                    padding: 10px;
                    background-color: #1472FF;
                    color: #fff;
                    border-radius: 50px;
                    margin-top: 20px;
                    font-size: 20px;
                    cursor: pointer;
                }
                img{
                    width: 90%;
                }
            }
        }
    }
</style>